var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodiconVerifiedFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58769 18.4008H10.4752L12.6252 16.2508H15.6252L16.2502 15.6258V12.6008L18.4252 10.4508V9.56328L16.2877 7.41328V4.36328L15.6627 3.75078H12.6252L10.4752 1.61328H9.58769L7.5002 3.75078H4.4127L3.7502 4.37578V7.41328L1.6377 9.56328V10.4508L3.7502 12.6008V15.6258L4.4127 16.2508H7.5002L9.58769 18.4008Z",
    fill: "#F4CF67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8373 8.16141C13.6208 7.94613 13.2691 7.94627 13.0522 8.16141L9.51851 11.6693L7.94793 10.1103C7.73106 9.89499 7.37952 9.89499 7.16265 10.1103C6.94578 10.3255 6.94578 10.6745 7.16265 10.8898L9.12579 12.8385C9.23415 12.9461 9.37625 13 9.51836 13C9.66047 13 9.8027 12.9462 9.91107 12.8385L13.8373 8.94091C14.0542 8.72578 14.0542 8.37667 13.8373 8.16141Z",
    fill: "#7C63A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodiconVerifiedFilled);
export default __webpack_public_path__ + "static/media/codicon_verified-filled.69990b2abcab88b35af8eefdc49c7cf5.svg";
export { ForwardRef as ReactComponent };